import { useLingui } from "@lingui/react/macro";
import { FilterBanner } from "@/components/FilterBanner/FilterBanner";
import { usePlanningFilterBannerItem } from "./PlanningContext";

export const PlanningFilterBannerSection = ({
  timeFilterBannerItem,
  competenceFilterBannerItem,
  teamFilterBannerItem,
  onClearAllFilters,
}: {
  timeFilterBannerItem:
    | { name: string; value: string; onClear: () => void }
    | undefined;
  competenceFilterBannerItem:
    | { name: string; value: string; onClear: () => void }
    | undefined;
  teamFilterBannerItem:
    | { name: string; value: string; onClear: () => void }
    | undefined;
  onClearAllFilters: () => void;
}) => {
  const { t } = useLingui();
  const patientOrActivityFilterItem = usePlanningFilterBannerItem(
    t`Patient/aktivitet`,
  );

  return (
    <FilterBanner
      filters={[
        timeFilterBannerItem,
        competenceFilterBannerItem,
        teamFilterBannerItem,
        patientOrActivityFilterItem,
      ]}
      onClearAllFilters={onClearAllFilters}
    />
  );
};
